import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import store from '@/store/index';

const { isNavigationFailure, NavigationFailureType } = Router;

Vue.use(Router);

const router = new Router({
    routes,
    base: '/',
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 };
    }
});

router.beforeEach((to, from, next) => {
    const requiredPermissions = to.matched
        .flatMap((record) => record.meta?.requiresPermissions)
        .filter((value) => !!value);
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

    const userPermissions = store.getters['auth/getPermissions'];
    if (!Array.isArray(userPermissions)) throw new Error('userPermissions should be an Array');
    const userHasRequiredPermissions = requiredPermissions.every((permission) =>
        userPermissions?.includes(permission)
    );
    const isUserLoggedIn = !!store.getters?.getIsLoggedIn;

    if (requiresAuth && !isUserLoggedIn) {
        next({ name: 'login', query: { previous: to.path } });
        return;
    }

    if (!userHasRequiredPermissions) {
        next({ name: 'home' });
    }

    next();
});

const originalPush = Router.prototype.push;

Router.prototype.push = function push (location) {
    const locationName = typeof location === 'string' ? location : location.name;

    if (locationName === 'login' && locationName === this.currentRoute.name) return;
    return originalPush.call(this, location).catch((failure) => {
        if (
            !isNavigationFailure(failure, NavigationFailureType.redirected) &&
      !isNavigationFailure(failure, NavigationFailureType.duplicated)
        ) {
            throw failure;
        }
    });
};

export default router;
